import { authService, Admin } from "../services/authService";

/**
 * Get the current authenticated admin
 */
export const getCurrentAdmin = (): Admin | null => {
  return authService.getAdmin();
};

/**
 * Check if user is authenticated
 */
export const isAuthenticated = (): boolean => {
  return authService.isAuthenticated();
};

/**
 * Get the JWT token
 */
export const getToken = (): string | null => {
  return authService.getToken();
};

/**
 * Logout and clear all auth data
 */
export const logout = async (): Promise<void> => {
  await authService.logout();
  // Redirect to login page
  window.location.href = "/admin/login";
};

/**
 * Set authentication data after login
 */
export const setAuthData = (authResponse: {
  accessToken: string;
  admin: Admin;
}): void => {
  authService.setAuthData(authResponse);
};











